import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class VarificationService {

  constructor(private http: HttpClient) { }
  verifyDriver(id: any, payload: any) {

    return this.http.patch(urls.API_URL + `drivers/${id}/manage`, payload)
      .pipe(catchError(errorHandl));
  }

  verifyCompany(id: any, payload: any) {
    return this.http.patch(urls.API_URL + urls.COMPANIES + `/${id}/manage`, payload)
      .pipe(catchError(errorHandl));
  }

  verifyVehicle(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `vehicles/${id}/manage`, payload)
      .pipe(catchError(errorHandl));
  }
  
  informationViaEmail(id: any, payload: any) {
    return this.http.post(urls.API_URL + urls.COMPANIES + `/${id}/missing-fields`, payload)
  }

  driverInformationViaEmail(id: any, payload: any) {
    return this.http.post(urls.API_URL + `drivers/${id}/missing-fields`, payload)
  }

  vehicleInformationViaEmail(id: any, payload: any) {
    return this.http.post(urls.API_URL + `vehicles/${id}/missing-fields`, payload)
  }
  // approved driver
  approvedDriver(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `drivers/${id}/approve`, payload)
      .pipe(catchError(errorHandl));
  }
  // approved vehicles
  approvedVehicle(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `vehicles/${id}/approve`, payload)
      .pipe(catchError(errorHandl));
  }
  // approved company
  approvedCompany(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `companies/${id}/approve`, payload)
      .pipe(catchError(errorHandl));
  }

  disApprovedCompanyField(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `companies/${id}/field-review`, payload)
      .pipe(catchError(errorHandl));
  }

  disApprovedDriverField(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `drivers/${id}/field-review`, payload)
      .pipe(catchError(errorHandl));
  }

  disApprovedVehicleField(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `vehicles/${id}/field-review`, payload)
      .pipe(catchError(errorHandl));
  }
}
